// extracted by mini-css-extract-plugin
export default {"container":"AidForm_container__YVA2C","column":"AidForm_column__LUp2p","btn":"AidForm_btn__-1O++"};